import { render } from "./PlanLoader.vue?vue&type=template&id=18572a1c&scoped=true&ts=true"
import script from "./PlanLoader.vue?vue&type=script&lang=ts"
export * from "./PlanLoader.vue?vue&type=script&lang=ts"

import "./PlanLoader.vue?vue&type=style&index=0&id=18572a1c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18572a1c"]])

export default __exports__